<template>
  <UserArea subject="maths">
    <div class="sf-container">
      <MathLevelYearTabs v-if="yearTabs" v-model="defaultYear" class="tw-mb-4" />
      <DbMathLevels 
        v-if="isReady" 
        :default-year="defaultYear" 
        :show-year-paging="yearPaging" 
        :teacher-mode="false"
      />
    </div>
  </UserArea>
</template>

<script lang="ts">
import DbMathLevels from "@/components/dashboard/DbMathLevels.vue";
import MathLevelYearTabs from "@/components/dashboard/MathLevelYearTabs.vue";
import UserArea from "@/components/permission/UserArea.vue";
import apiCall from "@/func/net/apiCall";
import userHasRole from "@/func/user/userHasRole";
import { defineComponent } from "vue";

export default defineComponent({
  components: { DbMathLevels, UserArea, MathLevelYearTabs },
  data() {
    return {
      isReady: false,
      defaultYear: 1,
    };
  },
  computed: {
    yearPaging() {
      return userHasRole(this.$currentUser.value, ['individual', 'student']);
    },
    yearTabs() {
      return userHasRole(this.$currentUser.value, ['teacher', 'sfAdmin', 'sfGameDev', 'sfEditor']);
    }
  },
  mounted() {
    this.refreshStudentYear();
  },
  methods: {
    async refreshStudentYear() {
      if(this.$currentUser.value) {
        if(userHasRole(this.$currentUser.value, ['individual'])) {
          this.defaultYear = this.$currentUser.value.maths_level || 1;
        } else if(userHasRole(this.$currentUser.value, ['student'])) {
          const redData = await apiCall('student/maths-objectives-year');
          if(redData.success) {
            this.defaultYear = redData.data.year;
          }
        }
      }
      this.isReady = true;
    }
  }
});
</script>